"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
var Link;
(function (Link) {
    Link.type = 'link';
    //  {
    //   // domain?: string;
    //   // allowFrame?: boolean;
    // }
})(Link || (exports.Link = Link = {}));
//# sourceMappingURL=Link.js.map